<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <div>
    <!-- Add Cart Modal -->
    <modal id="addCartModal" v-if="selectedArticle">
      <div slot="body" class="modal-body add-cart-box text-center">
        <p class="html-content" v-html="translations.addToCartSuccessMessage"></p>
        <h4 id="productTitle">
          {{ selectedArticle.title }}
        </h4>
        <img
          :src="`${baseUrl}${selectedArticle.highlightedImageUrl}`"
          id="productImage"
          width="100"
          height="100"
          alt="adding cart image"
        />
        <div class="btn-actions">
          <router-link :to="{ name: 'ShoppingCart' }" data-dismiss="modal">
            <button class="btn-primary">{{translations.goToShoppingCart}}</button>
          </router-link>
          <button class="btn-primary" data-dismiss="modal">
            {{translations.continueShopping}}
          </button>
        </div>
      </div>
    </modal>
    <modal id="quick-preview-article" v-if="quickArticle">
      <div class="modal-body" slot="body">
        <quick-preview :key="quickArticle.articleId"/>
      </div>
    </modal>
    <div class="container pb-5">
      <div class="row">
        <div class="col-12">
          <nav class="toolbox mb-4 row">
            <div class="col-12 col-sm-6 d-flex">
              <div class="toolbox-item toolbox-sort">
              </div>
              <!-- End .toolbox-item -->
            </div>
            <!-- End .toolbox-left -->
            <div
              class="
                col-12 col-sm-6
                justify-content-between
                justify-content-md-end
                align-items-center d-flex
              "
            >
              <div class="layout-modes d-none d-md-flex justify-content-end">
              <div
                class="layout-btn btn-grid"
                title="Grid"
                :class="{ active: layout === 'grid' }"
                @click="layout = 'grid'"
              >
                <i class="fa fa-th"></i>
              </div>
              <div
                class="layout-btn btn-list"
                title="List"
                :class="{ active: layout === 'list' }"
                @click="layout = 'list'"
              >
                <i class="fa fa-th-list"></i>
              </div>
              <div
                class="layout-btn btn-bars"
                title="Bars"
                :class="{ active: layout === 'bars' }"
                @click="switchLayout('bars')"
              >
                <i class="fas fa-bars"></i>
              </div>
            </div>
            <!-- End .layout-modes -->
            </div>
            <!-- End .toolbox-item -->
          </nav>
          <div class="row row-sm" v-if="articles && articles.length > 0 && layout === 'grid'">
            <div
              class="col-6 col-md-4 col-lg-3 mb-2"
              v-for="item in articles"
              :key="item.articleId"
            >
              <div class="product-default inner-quickview inner-icon bg-white h-100 mb-0">
                <figure>
                  <router-link
                    :to="{
                      name: 'Article', params: { id: item.articleId, slug: slugify(item.title) }
                    }"
                  >
                    <Photo
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <Photo src="assets/images/no-image.jpg" v-else />
                  </router-link>
                  <div
                    class="label-group"
                    v-if="item.salePrice < item.originalPrice && item.salePrice"
                  >
                    <span class="product-label label-cut">
                      {{ item.discount | percentage }}%
                    </span>
                  </div>

                  <div class="btn-icon-group">
                    <button
                      v-if="!item.disableSelling || canPassRestrictions"
                      class="btn-icon btn-add-cart"
                      @click="addToCart(item)"
                    >
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="icon-bag" v-else />
                    </button>
                  </div>
                  <button
                    class="btn btn-sm btn-quickview"
                    data-toggle="modal"
                    @click="getQuickArticle(item.articleId)"
                  >
                    {{ translations.quickPreview }}
                  </button>
                </figure>
                <div class="product-details">
                  <div class="category-wrap">
                    <div class="category-list">
                      <router-link
                        class="product-category"
                        exact
                        :to="{ name: 'Brand',
                         params: { id: item.brandId, title: item.brand.replace(/\s+/g, '-') } }"
                      >
                        {{ item.brand }}
                      </router-link>
                    </div>
                    <a
                      href="#"
                      @click.stop.prevent="toggleWishlistItem(item.articleId)"
                      class="btn-icon-wish"
                    >
                      <i class="icon-heart"></i>
                    </a>
                  </div>
                  <h2 class="product-title">
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: item.articleId, slug: slugify(item.title) }
                      }"
                    >
                      {{ item.title }}
                    </router-link>
                  </h2>
                  <div class="ratings-container">
                    {{ translations.forms.labels.code }}: {{ item.code }}
                    <!-- End .product-ratings -->
                  </div>
                  <!-- End .product-container -->
                  <div class="price-box" v-if="canViewPrices && !item.disableSelling">
                    <span class="product-price">
                      {{ (item.salePrice || item.originalPrice) | money3WithCurrency }}
                    </span>
                    <span
                      class="old-price"
                      v-if="item.salePrice < item.originalPrice && item.salePrice"
                    >
                      {{ item.originalPrice | money3 }} KM
                    </span>
                  </div>
                  <button
                    v-if="(item.disableSelling || (!item.stockAmount && !allowOrderingStockZero))
                     && !canPassRestrictions"
                    class="btn btn-primary btn-sm py-2 px-0 text-center btn-block"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                  <!-- End .price-box -->
                </div>
                <!-- End .product-details -->
              </div>
            </div>
          </div>
          <div class="row row-sm" v-if="articles && articles.length === 0">
            <div class="col-12">
              <div class="alert alert-info">
                {{ translations.noResultsAccordingToTheGivenParameters }}.
              </div>
            </div>
          </div>

          <div class="row row-sm" v-if="layout === 'list' && articles && articles.length > 0">
            <div
              class="col-6 col-sm-12 product-default left-details product-list"
              v-for="item in articles"
              :key="item.articleId"
            >
              <figure>
                <router-link
                  :to="{
                    name: 'Article', params: { id: item.articleId, slug: slugify(item.title) }
                  }"
                >
                  <img
                    :src="`${baseUrl}${item.highlightedImageUrl}`"
                    v-if="item.highlightedImageUrl"
                  />
                  <img src="assets/images/no-image.jpg" v-else />
                  <div class="label-group" style="position: absolute; top: 5px; left: 5px;">
                    <span class="product-label label-cut">
                      {{ item.discount | percentage }}% </span>
                  </div>
                </router-link>
              </figure>
              <div class="product-details product-details-list">
                <div class="category-list">
                  <a class="product-category">{{ item.brand }}</a>
                </div>
                <h2 class="product-title">
                  <router-link
                    :to="{
                      name: 'Article',
                      params: { id: item.articleId, slug: slugify(item.title) }
                    }"
                  >
                    {{ item.title }}
                  </router-link>
                </h2>
                <div class="ratings-container">
                  {{ translations.forms.labels.code }}: {{ item.code }}
                  <!-- End .product-ratings -->
                </div>
                <!-- End .product-container -->
                <p class="product-description">
                  {{ item.shortDescription }}
                </p>
                <div class="price-box" v-if="canViewPrices && !item.disableSelling">
                  <span class="product-price">
                    {{ (item.salePrice || item.originalPrice) | money3WithCurrency }}
                  </span>
                  <span
                    class="old-price"
                    v-if="item.salePrice < item.originalPrice && item.salePrice"
                  >
                    {{ item.originalPrice | money3 }} KM
                  </span>
                </div>
                <!-- End .price-box -->
                <div class="product-action">
                  <div class="product-single-qty product-list-quantity" v-if="!item.disableSelling">
                    <div class="input-group">
                      <span
                        class="input-group-btn input-group-prepend"
                        @click="setQuantity(item, -1)"
                      >
                        <button class="btn btn-outline btn-down-icon" type="button" />
                      </span>
                      <input
                        class="horizontal-quantity form-control"
                        v-model.number="item.quantity"
                      />
                      <span
                        class="input-group-btn input-group-append"
                        @click="setQuantity(item, 1)"
                      >
                        <button class="btn btn-outline btn-up-icon" type="button" />
                      </span>
                    </div>
                  </div>
                  <button
                    v-if="!item.disableSelling || canPassRestrictions"
                    class="btn-icon btn-add-cart"
                    @click="addToCart(item)"
                  >
                    <i class="sicon-equalizer" v-if="item.hasAttributes" />
                    <i class="icon-bag" v-else />
                    {{ item.hasAttributes ? translations.chooseOptions : translations.addToCart }}
                  </button>
                  <button
                    v-if="(item.disableSelling || (!item.stockAmount && !allowOrderingStockZero))
                     || !canPassRestrictions"
                    class="btn-icon btn-add-cart"
                    @click="showOutOfStockModal(item)"
                  >
                  {{ translations.availableOnRequest }}
                  </button>
                  <a
                    href="#"
                    @click.stop.prevent="toggleWishlistItem(item.articleId)"
                    class="btn-icon-wish"
                  >
                    <i class="icon-heart"></i>
                  </a>
                  <button class="btn-quickview" @click="getQuickArticle(item.articleId)">
                    <i class="fas fa-external-link-alt"></i>
                  </button>
                </div>
              </div>
              <!-- End .product-details -->
            </div>
          </div>

          <div
            class="table-product-list"
            v-if="layout === 'bars' && articles && articles.length > 0"
          >
            <table class="table text-left">
              <thead>
                <tr>
                  <th>{{ translations.manufacturer }}</th>
                  <th>{{ translations.forms.labels.code }}</th>
                  <th>{{ translations.productName }}</th>
                  <th>{{ translations.preview }}</th>
                  <th v-if="canViewPrices">{{ translations.price }}</th>
                  <th>{{ translations.discount }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in articles" :key="item.articleId">
                  <td>
                    {{ item.brand }}
                  </td>
                  <td>
                    {{ item.code }}
                  </td>
                  <td>
                    <router-link
                      :to="{
                        name: 'Article',
                        params: { id: item.articleId, slug: slugify(item.title) }
                      }"
                    >
                      {{ item.title }}
                    </router-link>
                  </td>
                  <td>
                    <img
                      class="small-product-list-img"
                      :src="`${baseUrl}${item.highlightedImageUrl}`"
                      v-if="item.highlightedImageUrl"
                    />
                    <img class="small-product-list-img" src="assets/images/no-image.jpg" v-else />
                  </td>
                  <td v-if="canViewPrices">
                    <span v-if="item.disableSelling">N/A</span>
                    <span v-else>{{ item.originalPrice | money3 }}KM</span>
                  </td>
                  <td>{{ (item.discount.toFixed(2).replace('.', ',') ) || 0 }}%</td>
                  <td class="order-actions justify-content-end">
                    <div class="product-single-qty" v-if="!item.disableSelling">
                      <div class="input-group bootstrap-touchspin">
                        <span
                          class="input-group-btn input-group-prepend"
                          @click="setQuantity(item, -1)"
                        >
                          <button class="btn btn-outline btn-down-icon" type="button" />
                        </span>
                        <input
                          class="horizontal-quantity form-control"
                          v-model.number="item.quantity"
                        />
                        <span
                          class="input-group-btn input-group-append"
                          @click="setQuantity(item, 1)"
                        >
                          <button class="btn btn-outline btn-up-icon" type="button" />
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="!item.disableSelling || canPassRestrictions"
                      class="btn-icon btn-add-cart"
                      @click="addToCart(item)"
                    >
                      <i class="sicon-equalizer" v-if="item.hasAttributes" />
                      <i class="fas fa-shopping-bag" v-else />
                    </div>
                    <div
                      v-if="(item.disableSelling || (!item.stockAmount && !allowOrderingStockZero))
                      && !canPassRestrictions"
                      class="btn-icon" role="button"
                      @click="showOutOfStockModal(item)"
                    >
                      <button
                        class="paction add-cart"
                      >
                      {{ translations.availableOnRequest }}
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              class="d-flex justify-content-end mt-1"
              v-if="showAddAllButton"
              @click="addSelectedToCart"
            >
              <button class="btn btn-primary" type="button">
                <i class="fas fa-shopping-bag" /> {{ translations.addSelected }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- End .row -->
    </div>
    <!-- End .container -->
  </div>
</template>

<script>
import config from '@/config';
import api from '@/services/api';
import slugify from '@/filters/slugify';
import helpers from '@/services/helpers';

import Photo from '@/components/shared/Image.vue';
import Modal from '@/components/shared/modal/Modal.vue';
import QuickPreview from '@/components/shared/article/QuickPreview.vue';

import { translations } from '@/mixins';

export default {
  name: 'SalesView',
  mixins: [translations],
  metaInfo() {
    return {
      title: 'Akcija - Eurosan B2B web shop',
      meta: [
        { name: 'description', content: 'Novosti iz svijeta Eurosan grupacije.' },
      ],
    };
  },
  components: {
    QuickPreview,
    Photo,
    Modal,
  },
  data() {
    return {
      actionName: 'getNewlyAddedArticles',
      layout: 'grid', // Can be list or grid
      layouts: ['grid', 'list'],
      selectedArticle: null,
    };
  },
  computed: {
    canPassRestrictions() {
      return this.profile?.userData?.articleAlwaysVisibleOnWeb;
    },
    articles() {
      return this.$store.getters.getArticlesOnSale;
    },
    baseUrl() {
      return config.baseUrl;
    },
    quickArticle() {
      return this.$store.getters.getQuickArticle;
    },
    loggedUser() {
      return this.$store.getters.getLoggedUser;
    },
    showAddAllButton() {
      return this.articles.some((item) => item.quantity > 0);
    },
    allowOrderingStockZero() {
      return this.$store.getters.getAllowOrderingStockZero;
    },
    profile() {
      return this.$store.getters.getProfile;
    },
    canViewPrices() {
      return this.profile.userData.canViewPrices;
    },
  },
  methods: {
    slugify,
    showOutOfStockModal(item) {
      this.$store.dispatch('showOutOfStockModal', { articleId: item.articleId });
    },
    addSelectedToCart() {
      [...this.articles].filter(
        (item) => item.quantity > 0,
      ).forEach(
        (item) => {
          this.addToCart(item);
        },
      );
    },
    switchLayout(layout) {
      this.layout = layout; // 'bars';
      this.articles.map((item) => {
        // eslint-disable-next-line no-param-reassign
        item.quantity = layout === 'bars' ? 0 : 1;
        return item;
      });
    },
    toggleWishlistItem(articleId) {
      api.toggleWishlistItem(articleId).then((response) => {
        this.$toast.info(response.data.info);
        this.$store.dispatch('getWishList');
      });
    },
    addToCart(item) {
      if (item.hasAttributes || (!item.stockAmount && !this.allowOrderingStockZero)) {
        this.$router.push({ name: 'Article', params: { id: item.articleId, slug: slugify(item.title) } });
        return;
      }

      if (this.layout === 'bars' && item.quantity <= 0) {
        return;
      }
      this.selectedArticle = item;
      api
        .addToShoppingCart({
          articleId: item.articleId,
          quantity: item.minOrderQuantity || 1,
        })
        .then(() => {
          this.$toast.info(helpers.getAddToCartToastMessage(item));
          this.$store.dispatch('getShoppingCart');
        }).catch((err) => {
          this.$toast.error(err.response.data.info, { timeout: 4000 });
          this.$store.dispatch('getShoppingCart');
        });
    },
    getQuickArticle(articleId) {
      this.$store.dispatch('getQuickViewArticle', articleId).then(() => {
        this.$store.dispatch('getArticleVariations', articleId).then(() => {
          this.$store.dispatch('getAttributes', { retrieveAll: true });
          $('#quick-preview-article').modal('show');
        });
      });
    },
    setQuantity(item, num) {
      if (item.quantity <= 0 && num === -1) return;
      // eslint-disable-next-line no-param-reassign
      item.quantity += num;
    },
    handleScroll() {
      localStorage.setItem('saleScrollPosition', window.scrollY);
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const scrollPosition = localStorage.getItem('saleScrollPosition');
    if (scrollPosition) {
      window.scrollTo({ top: parseInt(scrollPosition, 10), behavior: 'smooth' });
    }
    this.$store.dispatch('getArticlesOnSale', {
      isSortAscending: false,
      retrieveAll: true,
    });
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
.product-default .product-title {
  display: block;
  width: 100%;
}

.product-list .product-details {
  width: calc(100% - 270px);
}

.category-checkbox {
  margin-top: 0;
  margin-bottom: 1rem;
}

.custom-color-label {
  width: 20px;
  height: 20px;
  background: black;
}

.custom-color-label {
  width: 6rem;
  height: 2rem;
}

.layout-btn {
  cursor: pointer;
}

.order-actions {
  display: flex;
  border-top: none !important;
  margin-top: 10px;

  .product-single-qty {
    max-width: unset;
    max-height: unset;
  }

  .product-single-qty .bootstrap-touchspin.input-group {
    max-height: 30px;
  }

  .product-single-qty .bootstrap-touchspin .form-control {
    max-height: 30px;
  }

  i {
    color: #1e84bc;
    font-size: 1.7rem;
    margin-right: 1.5rem;
    padding-left: 5px;
  }

  .btn-icon.btn-add-cart {
    display: inline-block;
    padding-top: 5px;
    line-height: 1;
    height: 20px;
    margin-left: 10px;
  }
}

.btn-add-cart.hidden {
  opacity: 0.5;
}

.product-list-quantity {
  height: 37px;
  margin-bottom: 5px;
  margin-right: 5px;

  .horizontal-quantity {
    height: 37px;
  }
}

.product-default:hover figure img:first-child {
  opacity: 1;
}

.html-content a {
  color: #3598DB;
}
</style>
